export const REDUX_MODAL_TYPES = {
  MAIL_TEMPLATE: 'MAIL_TEMPLATE',
  ASSIGN_TO: 'ASSIGN_TO',
  MARKET_PRICE: 'MPRICE',
  ETS: 'ETS_MODAL',
  EDIT_MODAL: 'EDIT_MODAL',
  DELETE_MODAL: 'DELETE_MODAL',
  EDIT_HISTORY: 'EDIT_HISTORY',
  ADD_CONTACT: 'ADD_CONTACT',
  ADD_COST: 'ADD_COST',
  COMPANY_FLOW: 'COMPANY_FLOW',
  INFORMATIVE_MODAL: 'INFORMATIVE_MODAL',
  SET_PRICE_BOX_ID: 'SET_PRICE_BOX_ID',
  WELCOME_MODAL: 'WELCOME_MODAL',
  SHARE_LOAD_BOX: 'SHARE_LOAD_BOX',
  CARRIER_SHARE_BOX: 'CARRIER_SHARE_BOX',
  UPDATE_PAYMENT_TERMS: 'UPDATE_PAYMENT_TERMS'
}

export const dispatchETS = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.ETS,
  payload: item
})

export const dispatchEditModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.EDIT_MODAL,
  payload: item
})

export const dispatchDeleteModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.DELETE_MODAL,
  payload: item
})

export const dispatchEditHistoryModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.EDIT_HISTORY,
  payload: item
})

export const dispatchAddContactModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.ADD_CONTACT,
  payload: item
})

export const dispatchAddContactModalOnSave = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.ADD_CONTACT,
  payload: item
})

export const dispatchAddCost = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.ADD_COST,
  payload: item
})

export const dispatchCompanyFlowModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.COMPANY_FLOW,
  payload: item
})

export const dispatchInformativeModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.INFORMATIVE_MODAL,
  payload: item
})

export const dispatchSetPriceBoxId = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.SET_PRICE_BOX_ID,
  payload: item
})

export const dispatchWelcomeModal = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.WELCOME_MODAL,
  payload: item
})

export const dispatchShareLoadBox = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.SHARE_LOAD_BOX,
  payload: item
})

export const dispatchCarrierShareBox = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.CARRIER_SHARE_BOX,
  payload: item
})

export const dispatchUpdatePaymentTerms = (item) => (dispatch) => dispatch({
  type: REDUX_MODAL_TYPES.UPDATE_PAYMENT_TERMS,
  payload: item
})
